<!-- mettal-3\src\components\View622.vue -->
<template>
  <div class="view-124">
    <div class="rectangle-113"></div>
    <!-- <img
      class="image-6"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/---------------20.png"
      alt="image"
    /> -->
    <view632 />
  </div>
</template>

<script>
import View632 from "./View632";
export default {
  name: "View622",
  components: {
    View632,
  },
};
</script>

<style>
.view-124,
.image-6,
.view-125,
.image-7,
.view-127,
.image-8,
.view-128,
.image-10 {
  height: 101px;
  left: 0;
  position: absolute;
  top: 0;
  width: 1506px;
}

.rectangle-113,
.rectangle-113-1,
.rectangle-113-2,
.rectangle-113-3 {
  background-color: var(--azure-radiance-2);
  height: 101px;
  left: 0;
  position: absolute;
  top: 0;
  width: 1428px;
}
</style>
